export type AddOwnProfessionalLinkResult =
    | "exists"
    | "invalid-personal-code"
    | "no-relation"
    | "ok"
    | "restored"
    | "inconsistent-agb-code"
    | "agb-exists-in-organisation";
